import Stack from '@mui/material/Stack';
import { Divider } from '@mui/material';
import React from 'react';
import Title from '../../components/Title';
import Card from '@mui/material/Card';
import DashboardLayout from 'components/dashboardLayout/dashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import NewPasswordComponent from 'features/logon/newPasswordComponent';
import { PricingComponent } from 'components/PricingComponent/PricingComponent';
import { Grid } from '@mui/material';
import { pricing } from 'oems/pricing';
import { AvailableIndicator } from './components/availableIndicator';
import * as Styled from './pricing.styles';
import TooltipButton from '../../components/tooltipButton';
import { useTheme } from '@emotion/react';
import { useMediaQuery } from '@mui/material';

export function Pricing() {
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down('lg'));

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Card sx={{ display: 'flex', px: 3, py: 2, my: 2 }}>
        <Styled.TitleBox>
          <Styled.h2>Wybierz plan dostosowany do Twojej firmy</Styled.h2>
          <Styled.h5>... i ciesz się wszystkimi możliwościami najszybszego programu do faktur.</Styled.h5>
        </Styled.TitleBox>
        {!mobile && (
          <Stack direction="row" sx={{ p: 2 }} justifyContent="flex-start">
            <Grid container alignItems="center" justifyContent={'right'} spacing={0} sx={{ background: 'transparent' }}>
              <Grid item xs={12 / 5} />
              <Grid item xs={12 / 5} spacing={0}>
                <PricingComponent
                  current
                  type="free"
                  planName={pricing.pricingPlans.free.label}
                  description={pricing.pricingPlans.free.description}
                  price={pricing.pricingPlans.free.price}
                  subPrice={pricing.pricingPlans.free.subPrice}
                  productId={pricing.pricingPlans.free.productId}
                  productCode={pricing.pricingPlans.free.productCode}
                />
              </Grid>
              <Grid item xs={12 / 5} spacing={0}>
                <PricingComponent
                  type="minimum"
                  planName={pricing.pricingPlans.minimum.label}
                  description={pricing.pricingPlans.minimum.description}
                  price={pricing.pricingPlans.minimum.price}
                  subPrice={pricing.pricingPlans.minimum.subPrice}
                  productId={pricing.pricingPlans.minimum.productId}
                  productCode={pricing.pricingPlans.minimum.productCode}
                />
              </Grid>
              <Grid item xs={12 / 5} spacing={0}>
                <PricingComponent
                  type="standard"
                  planName={pricing.pricingPlans.standard.label}
                  description={pricing.pricingPlans.standard.description}
                  price={pricing.pricingPlans.standard.price}
                  subPrice={pricing.pricingPlans.standard.subPrice}
                  productId={pricing.pricingPlans.standard.productId}
                  productCode={pricing.pricingPlans.standard.productCode}
                />
              </Grid>
              <Grid item xs={12 / 5} spacing={0}>
                <PricingComponent
                  type="advanced"
                  planName={pricing.pricingPlans.advanced.label}
                  description={pricing.pricingPlans.advanced.description}
                  price={pricing.pricingPlans.advanced.price}
                  subPrice={pricing.pricingPlans.advanced.subPrice}
                  productId={pricing.pricingPlans.advanced.productId}
                  productCode={pricing.pricingPlans.advanced.productCode}
                />
              </Grid>

              <Grid item xs={12 / 5} spacing={0}>
                <Styled.Stack></Styled.Stack>
              </Grid>
              <Grid item xs={12 / 5} spacing={0}></Grid>
              <Grid item xs={12 / 5} spacing={0}></Grid>
              <Grid item xs={12 / 5} spacing={0}></Grid>
              <Grid item xs={12 / 5} spacing={0}></Grid>
              {pricing.pricingItems.map((item, index) => {
                console.log(index + ' ' + item.free);
                return (
                  <>
                    <Styled.Grid item xs={12 / 5} spacing={0}>
                      <Stack alignItems="center" direction="row" justifyContent="left" textAlign="center">
                        <Styled.h3>{item.title}</Styled.h3>
                        {item.help && <TooltipButton message={item.help} iconSx={{ width: 20, height: 20 }} />}
                      </Stack>
                    </Styled.Grid>
                    <Styled.Grid item xs={12 / 5} spacing={0}>
                      <AvailableIndicator present={item.free} />
                    </Styled.Grid>
                    <Styled.Grid item xs={12 / 5} spacing={0}>
                      <AvailableIndicator present={item.minimum} />
                    </Styled.Grid>
                    <Styled.Grid item xs={12 / 5} spacing={0}>
                      <AvailableIndicator present={item.standard} />
                    </Styled.Grid>
                    <Styled.Grid item xs={12 / 5} spacing={0}>
                      <AvailableIndicator present={item.advanced} />
                    </Styled.Grid>
                    <Styled.Grid item xs={12}>
                      <Divider sx={{ marginTop: '5px' }} />
                    </Styled.Grid>
                  </>
                );
              })}
            </Grid>
          </Stack>
        )}
        {mobile && (
          <Stack direction="column" sx={{ p: 2 }} alignItems="center" spacing={3}>
            <Stack justifyContent="center">
              <PricingComponent
                current
                type="free"
                planName={pricing.pricingPlans.free.label}
                description={pricing.pricingPlans.free.description}
                price={pricing.pricingPlans.free.price}
                subPrice={pricing.pricingPlans.free.subPrice}
                productId={pricing.pricingPlans.free.productId}
                productCode={pricing.pricingPlans.free.productCode}
              />
              {pricing.pricingItems.map((item, index) => {
                return (
                  <>
                    <Stack alignItems="center" direction="row" justifyContent="flex-start">
                      <Grid container>
                        <Grid item xs={9} spacing={0}>
                          <Stack alignItems="center" direction="row" justifyContent="flex-start">
                            <Styled.h6>{item.title}</Styled.h6>
                            {item.help && <TooltipButton message={item.help} iconSx={{ width: 15, height: 15 }} />}
                          </Stack>
                        </Grid>
                        <Grid item xs={3} spacing={0}>
                          <AvailableIndicator present={item.freeMobile} />{' '}
                        </Grid>
                      </Grid>
                    </Stack>
                  </>
                );
              })}
            </Stack>
            <Divider sx={{ marginTop: '5px' }} />
            <Stack>
              <PricingComponent
                type="minimum"
                planName={pricing.pricingPlans.minimum.label}
                description={pricing.pricingPlans.minimum.description}
                price={pricing.pricingPlans.minimum.price}
                subPrice={pricing.pricingPlans.minimum.subPrice}
                productId={pricing.pricingPlans.minimum.productId}
                productCode={pricing.pricingPlans.minimum.productCode}
              />
              {pricing.pricingItems.map((item, index) => {
                return (
                  <>
                    <Stack alignItems="center" direction="row" justifyContent="flex-start">
                      <Grid container>
                        <Grid item xs={9} spacing={0}>
                          <Stack alignItems="center" direction="row" justifyContent="flex-start">
                            <Styled.h6>{item.title}</Styled.h6>
                            {item.help && <TooltipButton message={item.help} iconSx={{ width: 15, height: 15 }} />}
                          </Stack>
                        </Grid>
                        <Grid item xs={3} spacing={0}>
                          <AvailableIndicator present={item.minimumMobile} />{' '}
                        </Grid>
                      </Grid>
                    </Stack>
                  </>
                );
              })}
            </Stack>
            <Divider sx={{ marginTop: '5px' }} />
            <Stack>
              <PricingComponent
                type="standard"
                planName={pricing.pricingPlans.standard.label}
                description={pricing.pricingPlans.standard.description}
                price={pricing.pricingPlans.standard.price}
                subPrice={pricing.pricingPlans.standard.subPrice}
                productId={pricing.pricingPlans.standard.productId}
                productCode={pricing.pricingPlans.standard.productCode}
              />
              {pricing.pricingItems.map((item, index) => {
                return (
                  <>
                    <Stack alignItems="center" direction="row" justifyContent="flex-start">
                      <Grid container>
                        <Grid item xs={9} spacing={0}>
                          <Stack alignItems="center" direction="row" justifyContent="flex-start">
                            <Styled.h6>{item.title}</Styled.h6>
                            {item.help && <TooltipButton message={item.help} iconSx={{ width: 15, height: 15 }} />}
                          </Stack>
                        </Grid>
                        <Grid item xs={3} spacing={0}>
                          <AvailableIndicator present={item.standardMobile} />{' '}
                        </Grid>
                      </Grid>
                    </Stack>
                  </>
                );
              })}
            </Stack>
            <Divider sx={{ marginTop: '5px' }} />
            <Stack>
              <PricingComponent
                type="advanced"
                planName={pricing.pricingPlans.advanced.label}
                description={pricing.pricingPlans.advanced.description}
                price={pricing.pricingPlans.advanced.price}
                subPrice={pricing.pricingPlans.advanced.subPrice}
                productId={pricing.pricingPlans.advanced.productId}
                productCode={pricing.pricingPlans.advanced.productCode}
              />
              {pricing.pricingItems.map((item, index) => {
                return (
                  <>
                    <Stack alignItems="center" direction="row" justifyContent="flex-start">
                      <Grid container>
                        <Grid item xs={9} spacing={0}>
                          <Stack alignItems="center" direction="row" justifyContent="flex-start">
                            <Styled.h6>{item.title}</Styled.h6>
                            {item.help && <TooltipButton message={item.help} iconSx={{ width: 15, height: 15 }} />}
                          </Stack>
                        </Grid>
                        <Grid item xs={3} spacing={0}>
                          <AvailableIndicator present={item.advancedMobile} />{' '}
                        </Grid>
                      </Grid>
                    </Stack>
                  </>
                );
              })}
            </Stack>
            <Divider sx={{ marginTop: '5px' }} />
          </Stack>
        )}
      </Card>
    </DashboardLayout>
  );
}

export default Pricing;
